export default __webpack_public_path__ + "5f9cb0d20285ee7465dcfe336c4a002f.png";